import React from 'react';
import Details from './Details';

function AccountSettings(): JSX.Element {
  return (
    <div>
      <Details />
    </div>
  );
}

export default AccountSettings;
